<template>
  <div
    class="faq-item"
    :class="{
      'faq-item--expanded': isOpen,
    }"
    @click="toggle">
    <h3 class="faq-item__question">
      {{question}}
      <icon-arrow-down class="faq-item__toggle" />
    </h3>
    <div class="faq-item__wrapper">
      <div class="faq-item__content" v-html="description"></div>
    </div>
  </div>
</template>

<script>
import IconArrowDown from '@/components/common/IconArrowDown.vue'

export default {
  name: 'AccordionItem',

  props: {
    question: {
      type: String,
      require: true
    },
    description: {
      type: String,
      require: true
    },
    isOpen: {
      type: Boolean,
      require: true
    },
    id: {
      type: Number,
      require: true
    }
  },

  components: {
    IconArrowDown
  },

  methods: {
    toggle() {
      this.$emit('toggle', this.id)
    }
  }
}

</script>

<style lang="scss" scoped>
@import "../../../assets/style/scss/vars";

h3 {
  margin: 0;
}

.faq-item {
  cursor: pointer;
  position: relative;
  padding: 28px 0 5px;
  transition: background-color .5s;

  &--expanded {
    background-color: #fff;

    .faq-item__question {
      color: #80B8E4;
    }

    .faq-item__toggle {
      transition: transform .5s;
      transform: rotate(180deg) translate(100%, -25%);
      fill: #80B8E4;
    }

    .faq-item__wrapper {
      height: 135px;
      opacity: 1;
    }
  }
}

.faq-item__question {
  font-family: $font-cabin;
  font-weight: map-get($font-weight, "medium");
  font-size: 20px;
  color: #fff;
  margin-left: 65px;
  margin-bottom: 23px;
  position: relative;
  transition: color .5s;
}

.faq-item__toggle {
  position: absolute;
  right: 0;
  transform: translate(-100%, 25%);
  transition: .5s;
  fill: #fff;
}

.faq-item__wrapper {
  height: 0;
  transition: height .5s, opacity .5s;
  overflow: hidden;
  opacity: 0;
}

.faq-item__content {
  font-family: $font-cabin;
  font-weight: map-get($font-weight, "regular");
  line-height: 1.57;
  font-size: 14px;
  padding: 0 45px 40px 65px;
}
</style>
